import React, { useMemo } from 'react';
import ReactTableGeneric from 'Components/ReactTableGeneric';

const AfasGrid = ({
    columns = [],
    rows = [],
    totalCount,
    toolbar,
    rowKey = 'id',
    renderActions,
    className = '',
    emptyMessage = 'Geen gegevens beschikbaar',
}) => {
  
    const tanstackColumns = useMemo(() => {
        const list = (columns || []).map((column) => ({
            id: column.key,
            accessorKey: column.key,
            header: column.label,
            size: column.width ? parseInt(column.width, 10) : undefined,
            cell: (info) => {
                const rowData = info.row.original;
                return column.render ? column.render(rowData) : rowData[column.key];
            },
        }));

        if (renderActions) {
            list.push({
                id: 'actions',
                header: 'Acties',
                cell: (info) => renderActions(info.row.original),
            });
        }

        return list;
    }, [columns, renderActions]);

    return (
        <div className={`afas-grid card shadow-sm ${className}`.trim()}>
            {toolbar ? <div className="afas-grid__toolbar card-header border-bottom py-2 bg-light">{toolbar}</div> : null}

            <div className="afas-grid__table-wrap p-0">
                <ReactTableGeneric
                    data={rows || []}
                    columns={tanstackColumns}
                    filters={{ search: false, pagination: true , columnSorting: true }}
                    tableClassName="table table-sm table-hover mb-0 align-middle"
                    emptyMessage={emptyMessage}
                    count={totalCount}
                />
            </div>
        </div>
    );
};

export default AfasGrid;
